var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.styleType === "normal"
    ? _c("div", [
        _c("input", {
          staticClass: "rp-input is-small",
          class: { "is-danger": _vm.status },
          attrs: {
            type: "text",
            placeholder: _vm.inputData.placeholder,
            maxlength: _vm.inputData.limit
          },
          domProps: { value: _vm.value },
          on: {
            input: function($event) {
              return _vm.updateValue($event.target.value)
            },
            blur: function($event) {
              return _vm.validateInput()
            }
          }
        }),
        _vm._v(" "),
        _vm.status === true
          ? _c("div", { staticClass: "validation-text" }, [
              _vm._v("\n    " + _vm._s(_vm.errorMessage) + "\n  ")
            ])
          : _vm._e()
      ])
    : _vm.styleType === "material"
    ? _c("div", { staticClass: "rp-material-form-input" }, [
        _c("label", { staticClass: "rp-material-form-label" }, [
          _c("input", {
            staticClass: "rp-material-input is-small",
            class: { "is-danger": _vm.status },
            attrs: {
              type: "text",
              maxlength: _vm.inputData.limit,
              placeholder: _vm.inputData.placeholder,
              required: ""
            },
            domProps: { value: _vm.value },
            on: {
              input: function($event) {
                return _vm.updateValue($event.target.value)
              },
              blur: function($event) {
                return _vm.validateInput()
              }
            }
          }),
          _vm._v(" "),
          _c("span", { staticClass: "rp-material-input-placeholder" }, [
            _vm._v(_vm._s(_vm.inputData.label))
          ])
        ]),
        _vm._v(" "),
        _vm.status === true
          ? _c("div", { staticClass: "validation-text" }, [
              _vm._v("\n    " + _vm._s(_vm.errorMessage) + "\n  ")
            ])
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7776b232", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7776b232","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/share/form/TextInput.vue
// module id = null
// module chunks = 